import React, {PropTypes} from 'react';
import moment from 'moment';
import ScheduleSquadList from './ScheduleSquadList.jsx';
import Panel from 'shared/Panel.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';

const ScheduleEventList = ({
  source,
  selectedDate,
  onEventSquadQuantityChange,
  onEventSquadAddClick,
  onEventSquadFeesClick,
  onNextDateClick,
  onQuantityChange,
  onAddClick
}) => (
  <div>
    {source.map((tournamentEvent, index) => (
      <Panel key={index}
        className="panel-primary"
        title={
          <span>
            {`${tournamentEvent.name} squads for ${moment(selectedDate).format('ddd, MMM Do')}`}
            <DisplayIf condition={tournamentEvent.isLinked}
              className="panel-sub-heading">
              {'One “Qty” is one doubles set and two singles entries.'}
              <br />
              {tournamentEvent.bundledParentNumberOfBowlers
                ? `For example: 2 teams (${tournamentEvent.bundledParentNumberOfBowlers * 2} bowlers)
                  should purchase ${tournamentEvent.bundledParentNumberOfBowlers} sets.`
                : ''
              }
            </DisplayIf>
          </span>
        }>
        <ScheduleSquadList
          source={tournamentEvent.squads}
          onQuantityChange={onEventSquadQuantityChange}
          onSquadFeesClick={onEventSquadFeesClick}
          onAddClick={onEventSquadAddClick}
          onNextDateClick={onNextDateClick}
        />
        {tournamentEvent.teamOwnedVirtualEvents.map((virtualEvent, index) =>
          <div 
            key={index} 
            style={{padding: 0}}>
            <div className="panel-heading">
              <div className="indent"
                style={{width: 80}} />
              <h2 className="panel-title">{virtualEvent.name}</h2>
            </div>
            <div className="panel-body">
              <div className="list-group">
                <div className="indent"
                  style={{width: 80}} />
                <div className="list-group-item-labeled">
                  <div className="list-group-item-labeled-child"
                    style={{width: 80}}>
                    <span>{'Price ($)'}</span>
                    <span>{virtualEvent.price.formatCurrency(2)}</span>
                  </div>
                  <div className="list-group-item-labeled-child"
                    style={{width: 80}}>
                    <span>{'Available'}</span>
                    <span>{'N/A'}</span>
                  </div>
                  <div className="list-group-item-labeled-child"
                    style={{width: 80}}>
                    <span>{'Quantity'}</span>
                    <input
                      style={{width: 80}}
                      value={virtualEvent.quantity}
                      type="number"
                      min="0"
                      step="1"
                      onChange={event => onQuantityChange(tournamentEvent.id, virtualEvent.id, event.target.value)} 
                    />
                  </div>
                  <div className="list-group-item-labeled-child"
                    style={{width: 100}}>
                    <button
                        className={virtualEvent.quantity > 0 ? 'btn btn-warning' : 'btn btn-link'}
                        type="button"
                        disabled={!virtualEvent.quantity}
                        onClick={() => onAddClick({
                          id: virtualEvent.id,
                          name: virtualEvent.name,
                          quantity: virtualEvent.quantity,
                          price: virtualEvent.price,
                          eventId: tournamentEvent.id
                        })}
                    ><i className="fa fa-shopping-cart" /> { virtualEvent.quantity > 0 ? `Add (${virtualEvent.quantity})` : 'Add'}
                    </button>
                  </div>
                  <div className="list-group-item-labeled-child"
                    style={{width: 80}}>
                    <span>{'In Cart'}</span>
                    <span>{virtualEvent.countInCart}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Panel>
    ))}
  </div>
);

ScheduleEventList.propTypes = {
  source: PropTypes.arrayOf(PropTypes.object),
  selectedDate: PropTypes.string,
  onEventSquadQuantityChange: PropTypes.func,
  onEventSquadAddClick: PropTypes.func,
  onEventSquadFeesClick: PropTypes.func,
  onNextDateClick: PropTypes.func,
  onQuantityChange: PropTypes.func,
  onAddClick: PropTypes.func  
};

ScheduleEventList.defaultProps = {
  source: []
};

export default ScheduleEventList;



// WEBPACK FOOTER //
// ./src/features/shared/ScheduleEventList.jsx